module.exports = "/_next/static/images/423255c949645aee63aa914ed8c69841-nucommunity-xs@2x.jpg";